<template>
  <div>
    <draggable class="mt-2" v-if="currentClassBreaks.length > 0"  v-model="classObject.entry_breaks" group="market" @start="drag=true" @end="drag=false" handle=".handle">
      <div v-for="(e, i) in currentClassBreaks" :key="i" > <!--:class="{ 'bg-blue-200': e.change=='UPDATE', 'bg-green-200': e.change=='NEW' }">-->
        <div v-if="e.type === 'break'" class="mt-0 py-1 px-2 md:px-4 bg-gray-700 text-white  sm:rounded-full">
          <div class="flex items-center justify-between">
            <div v-if="i !== 0 && !arrangeEntries" class="text-xl handle draggable mr-3">&#9776;</div>
            <!--<div v-else-if="!arrangeEntries" class="text-xl text-gray-500 mr-3 cursor-not-allowed">&#9776;</div>-->
            <div v-else class="text-xl mr-3 text-transparent">&#9776;</div>
            <div class="flex flex-col md:flex-row justify-between md:items-center flex-1">
              <div class="flex-shrink-0 text-lg sm:text-xl flex-1 text-center sm:text-left">
                {{e.name}}
                <!--<br class="md:hidden">--->
                <span class="text-base">({{e.entry_count}} entries)</span>
              </div>
              <div class="mr-3 flex flex-shrink items-center">
                <label class="hidden sm:block mr-1 flex-shrink-0 text-sm">Sub Division: </label>
                <select v-show="e.sub_division !== 'NEW'" @change="applyFocusCheck(e)" v-model="e.sub_division" class="block w-full bg-gray-100 border border-gray-300 text-gray-700 p-1 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                  <option :value="null" selected disabled>
                    Select a sub division
                  </option>
                  <option v-for="(d, index) in sub_divisions"  :key="index" :value="d">
                    {{d}}
                  </option>
                  <option :value="'NEW'">Add new sub division</option>
                  <option v-if="e.sub_division && e.sub_division !== 'NEW'" :value="null">Remove Sub Division</option>
                </select>
                <div v-show="e.sub_division === 'NEW'" class="w-full sm:w-auto md:flex-shrink-0 flex flex-col sm:flex-row items-center justify-center">
                  <input :ref="`sub:${e.name}`" v-model="new_division" placeholder="Type new subdivision" v-on:keyup.enter="addSubDivision(e)" class="w-full flex-1 appearance-none border border-gray-500 text-gray-700 rounded py-1 px-2 leading-tight">
                  <div class="mt-1 sm:mt-0">
                    <button type="button" @click="addSubDivision(e)" class="mx-1 inline-flex items-center rounded bg-green-500 hover:bg-green-600 px-2 py-1.5 text-xs font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Add</button>
                    <button type="button" @click="e.sub_division = null" class="mx-1 inline-flex items-center rounded bg-red-500 hover:bg-red-600 px-2 py-1.5 text-xs font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">X</button>
                  </div>
                </div>
                <span v-tooltip="{content: subDivisionHelpText, classes: ['w-128', 'p-2']}" class="inline-flex items-center rounded-md bg-gray-400/10 px-2 py-1 text-xs font-medium text-gray-400 ring-1 ring-inset ring-gray-400/20">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                  </svg>
                </span>
              </div>
            </div>
            <button v-if="i!==0 && !arrangeEntries" @click="removeBreak(i)" type="button"  class="inline-flex items-center rounded-md border border-transparent bg-red-600 px-1 sm:px-1.5 py-1 sm:py-1 text-xs sm:text-sm font-medium leading-4 text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
              <!-- Heroicon name: mini/plus -->
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 sm:w-4 h-4 sm:h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div v-else class="w-6">&nbsp;</div>
          </div>
        </div>
        <div v-else class="flex items-center justify-start py-1.5 mx-1.5 sm:mx-5 border-b  space-x-3 sm:space-x-8">
          <div v-if="arrangeEntries" class="text-xl handle draggable mr-3">&#9776;</div>
          <div v-if="!arrangeEntries" class="flex-shrink-0">
            <button class="px-2 py-0.5 text-xs border border-green-600 text-green-600 font-bold rounded-lg flex items-center hover:bg-green-600 hover:text-white hover:shadow" @click="addMarketClass_index(i)">
              + Class
            </button>
          </div>
          <div class="flex items-center sm:text-lg text-sm font-medium " id="what-what">
            <!--If Weight-->
            <div class="w-12 sm:w-16" v-if="class_calc.calculate_by === 'weight' || classObject.break_type==='weight'">
              {{e.entry_details.weight}}<span v-if="weightLabel.toLowerCase().includes('weight')">lbs</span>
            </div>
            <!--IF Age-->
            <div class="w-16 sm:w-20" v-else-if="e.entry_details.date_of_birth">
              {{formatDate(e.entry_details.date_of_birth)}}
            </div>
            <!--<div v-if="arrangeEntries" class="flex flex-col pl-1 text-xs">
              <button class="btn-super-small btn-gray-outline mb-1" @click="moveEntry(e, i, i - 1)">&uarr;</button>
              <button class="btn-super-small btn-gray-outline" @click="moveEntry(e, i, i + 1)">&darr;</button>
            </div> -->
          </div>
          <div class="">
            <div class="flex items-center font-medium text-base sm:text-lg space-x-1 sm:space-x-4 flex-wrap">
              <p class="w-48 truncate" v-tooltip="`${e.exhibitor.first_name} ${e.exhibitor.last_name}`.length > 20 ? `${e.exhibitor.first_name} ${e.exhibitor.last_name}` : ''">{{`${e.exhibitor.first_name} ${e.exhibitor.last_name}`}}</p>
              <p class="w-48 truncate text-xs sm:text-sm text-gray-700 font-medium" v-tooltip="`${e.entry_details.animal_id ? e.entry_details.animal_id : e.entry_details.name}`.length > 22 ? `${e.entry_details.animal_id ? e.entry_details.animal_id : e.entry_details.name}` : ''">{{e.entry_details.animal_id ? e.entry_details.animal_id : e.entry_details.name}}</p>
              <p class="text-xs sm:text-sm text-gray-700 font-medium">{{e.entry_details.breed }}</p>
            </div>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Vue from 'vue'

export default {
  components: {
    draggable
  },
  props: {
    selectedClass: String,
    currentClassBreaks: Array,
    show_book: Object,
    class_calc: Object,
    classObject: Object,
    // sub_divisions: Array,
    arrangeEntries: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sub_divisions: [],
      new_division: null,
      subDivisionHelpText: 'Optional: Use the subdivision tool to create subdivisions such as “lightweight,” “middleweight,” etc. Creating a subdivision will automatically generate a champion and reserve champion for that subdivision in your showbook, ex: “Lightweight champion.” This tool should not be used to name classes nor for breeds, but rather to group classes together into a subdivision based on weight or age. If no subdivisions are being used, just leave it blank!'
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    showDecode () {
      var obj = {}
      if (this.adminData) {
        this.adminData.event.shows.forEach(s => {
          obj[s.show_id] = s
        })
      }
      return obj
    },
    weightLabel () {
      let label = 'Weight'
      this.showDecode[this.show_book.show_id].entry_details.entry_details[0].fields.forEach(f => {
        if (f.model === 'weight') {
          label = f.label
        }
      })
      return label
    },
    currentClassIndex () {
      if (this.selectedClass) {
        let showBook = [...this.show_book.show_book]
        return showBook.filter((c, i) => {
          // if (c.entryType.toLowerCase() !== 'champion' && (this.class_calc.manual_use_class_name ? c.class_name : c.division) === this.selectedClass) {
          if (c.entryType.toLowerCase() !== 'champion' && c.class_name === this.selectedClass) {
            c.index = i
            return true
          }
        })[0].index
      } else {
        return []
      }
    }
  },
  methods: {
    applyFocusCheck (e) {
      if (e.sub_division === 'NEW') {
        let input = this.$refs[`sub:${e.name}`]
        setTimeout(() => {
          input[0].focus()
        }, 100)
      }
    },
    removeBreak (i) {
      Vue.delete(this.currentClassBreaks, i)
    },
    addMarketClass_index (i) {
      this.show_book.show_book[this.currentClassIndex].entry_breaks.splice(i, 0, {
        type: 'break',
        division: this.classObject.division,
        sub_division: null
      })
    },
    formatDate (date) {
      return this.Localized.formatDate(date, this.adminData.event.location_details.country)
    },
    addSubDivision (e) {
      if (this.new_division) {
        if (this.sub_divisions.indexOf(this.new_division === -1) && this.new_division !== 'NEW') {
          this.sub_divisions.push(this.new_division)
        }
      }
      e.sub_division = this.new_division
      this.new_division = null
    },
    resetSubDivisions () {
      this.sub_divisions = []
      this.currentClassBreaks.forEach(e => {
        if (this.sub_divisions.indexOf(e.sub_division) === -1 && e.sub_division) {
          this.sub_divisions.push(e.sub_division)
        }
      })
    },
    sortClass (order) {
      // Check if sub divisions and do a warning..
      let sortField = 'date_of_birth'
      if (this.class_calc.calculate_by === 'weight' || this.classObject.break_type === 'weight') {
        sortField = 'weight'
      }
      let first = this.currentClassBreaks.shift()
      first.sub_division = ''
      // remove all breaks
      this.currentClassBreaks.forEach((cb, i) => {
        if (cb.type === 'break') {
          Vue.delete(this.currentClassBreaks, i)
        }
      })
      if (order === 'ASC') {
        this.currentClassBreaks.sort((a, b) => a.entry_details[sortField] - b.entry_details[sortField])
      } else if (order === 'DESC') {
        this.currentClassBreaks.sort((a, b) => b.entry_details[sortField] - a.entry_details[sortField])
      } else {
        this.currentClassBreaks.sort((a, b) => 0.5 - Math.random())
      }
      this.currentClassBreaks.unshift(first)
      this.$refs.sortButton.close()
    }
  },
  watch: {
    selectedClass (newClass, OldClass) {
      this.resetSubDivisions()
      if (this.classObject.settings) {
        if (this.classObject.settings.pre_set_breaks) {
          this.classObject.settings.pre_set_breaks.split(',').forEach(d => {
            this.sub_divisions.push(d)
          })
        }
      }
    }
  },
  mounted () {
    this.resetSubDivisions()
    if (this.classObject.settings) {
      if (this.classObject.settings.pre_set_breaks) {
        this.classObject.settings.pre_set_breaks.split(',').forEach(d => {
          this.sub_divisions.push(d)
        })
      }
    }
  }
}
</script>

<style>

</style>
